import { BrowserRouter, Route, Routes } from "react-router-dom";
//css
import "./App.css";
//Components and Pages
import HomePage from "./Pages/HomePage/HomePage";
import TopNav from "./Components/NavBar/TopNav";

function App() {
  return (
    <BrowserRouter>
      <TopNav />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
